import React from 'react';
import { cn } from '@/utils/cn';

interface ActionBarProps {
  left?: React.ReactNode;
  right?: React.ReactNode;
  className?: string;
}

const ActionBar: React.FC<ActionBarProps> = ({ left, right, className }) => (
  <div
    className={cn(
      'h-12 border-b border-neutral-150 flex items-center justify-between px-6 bg-white sticky top-0 z-10',
      className
    )}
  >
    <div className="flex items-center gap-3 min-w-0">{left}</div>
    <div className="flex items-center gap-2 shrink-0">{right}</div>
  </div>
);

export { ActionBar };
